var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold",style:(_vm.estiloStatus),attrs:{"x-small":_vm.xsmall,"small":_vm.small}},[_vm._v(_vm._s(_vm.visita.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }